import { merge } from 'lodash';
import { defaults } from './defaults.js';
import { Node_Type } from 'wix-rich-content-common';
import { convertNodeDataToDraft } from 'ricos-content/libs/toDraftData';

const createHtmlData = (pluginData = {}, isRicosSchema = false) => {
  const htmlData = isRicosSchema ? convertNodeDataToDraft(Node_Type.HTML, pluginData) : pluginData;
  return merge({}, defaults(), htmlData);
};

export { createHtmlData };
//# sourceMappingURL=createHtmlData.js.map
